import service from '@/utils/request'
// 查询供应商银行信息
export function supplierBankIdList(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierBankId/supplierBankIdList',
        data: param
    })
}
// 查询供应商银行信息 不分页
export function supplierBankIdListAll() {
    return service.request({
        method: 'POST',
        url: '/app/supplierBankId/list',
    })
}
// 新增供应商银行信息
export function addSupplierBankID(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierBankId/add',
        data: param
    })
}
// 修改供应商银行信息
export function editSupplierBankID(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierBankId/edit',
        data: param
    })
}

// 批量删除供应商银行信息
export function batchDelSupplierBankID(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierBankId/batchDel',
        data: param
    })
}



// 删除供应商银行信息
export function delSupplierBankID(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierBankId/del',
        data: param
    })
}
// 导出供应商银行信息
export function exportSupplierBankID(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierBankId/export',
        data: param
    })
}
